<template>
  <div
    class="modal fade"
    id="EditBatchModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">
            <img class="register-icon" src="../assets/ico-edit.svg" /> EDITAR LOTE
          </h5>
          <button
            class="close"
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            ref="closeButton"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div class="modal-body">
          <form @submit.prevent="editBatch">
            <label>Lote: {{batchID}}</label><br />

            <label for="animal-type">Tipo do Animal</label>
            <br />
            <select
              id="animal-type"
              name="animal_type"
              class="form-control"
              v-model="form_animal_type"
              required
            >
              <option :value="null" disabled>Selecione o tipo</option>
              <option
                v-for="type in animalTypes"
                :key="type.pk"
                :value="type.pk"
              >
                {{ type.pk }} - {{ type.name }}
              </option>
            </select>
            
            <label>Peso Médio Inicial</label>
            <br />
            <input
              name="initial_weight"
              type="number"
              step="any"
              class="form-control"
              :value="inicial_weight"
              required
            />

            <label>Peso Desejado</label>
            <br />
            <input
              name="desired_weight"
              type="number"
              step="any"
              class="form-control"
              :value="desired_weight"
              required
            />

            <label>Quantidade Inicial de Animais</label>
            <br />
            <input
              name="initial_count"
              type="number"
              step="1"
              class="form-control"
              :value="initial_count"
              required
            />
            
            <label>Data de Acomodação Atual: {{dateFormat(accommodation)}}</label>
            <br />
            <input
              name="accommodation"
              type="date"
              placeholder="dd-mm-yyyy"
              class="form-control"
              v-model="form_accommodation"
              required
            />

            <label>Data de Nascimento <span class="optional-hint">(opcional)</span></label>
            <br />
            <input
              name="date_birth"
              type="date"
              placeholder="dd-mm-yyyy"
              class="form-control"
              v-model="form_date_birth"
            />

            <label>Idade do Lote</label>
            <br />
            <input
              type="text"
              class="form-control"
              :value="batchAgeDisplay"
              readonly
              tabindex="-1"
            />
            <button type="submit" :class="button">Atualizar</button>
          </form>
        </div>
      </div>
    </div>
    <SuccessAlert ref="successAlert" v-bind:message="messageSuccess" />
    <ErrorAlert ref="errorAlert" v-bind:message="messageFailure" />
  </div>
</template>

<script>
import ErrorAlert from "./ErrorAlert.vue";
import SuccessAlert from "./SuccessAlert.vue";
import { apiRoutes } from "../utils/api"

export default {
  name: "EditBatchModal",
  components: {
    ErrorAlert,
    SuccessAlert,
  },
  data() {
    return {
      messageSuccess: "Lote editado com sucesso",
      messageFailure: "Não foi possível editar o lote",
      button: "button",
      form_accommodation: "",
      form_date_birth: "",
      form_animal_type: null,
    };
  },
  props:["batchDetail"],
  watch: {
    batchDetail: {
      immediate: true,
      handler(detail) {
        this.form_accommodation = detail?.date_accomodation ?? ""
        this.form_date_birth = detail?.date_birth ?? ""
        this.form_animal_type = detail?.animal_type ?? this.batch?.animal_type ?? null
      },
    },
    batch: {
      immediate: true,
      handler(batch) {
        if (this.form_animal_type == null && batch?.animal_type != null) {
          this.form_animal_type = batch.animal_type
        }
      },
    },
  },
  async created() {
    const company = this.$store.getters.getCurrentUser?.company
    await this.$store.dispatch("fetchAnimalTypes", company)
  },
  methods: {
    dateFormat(date_to_format) {
      if (date_to_format == null) return "";

      let date = new Date(date_to_format);
      date.setDate(date.getDate() + 1);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      date = day + "/" + month + "/" + year;

      return `${date}`;
    },
    dateCompare(firstDate, secondDate) {
      return Math.ceil(
        Math.abs(new Date(secondDate) - new Date(firstDate)) / (1000 * 60 * 60 * 24)
      )
    },
    async editBatch(event) {
      if (this.button === "button-disable") return;
      
      const { accommodation, desired_weight, initial_count, initial_weight, date_birth, animal_type } =  Object.fromEntries(new FormData(event.target))

      document.body.style.cursor = "progress";
      this.button = "button-disable";

      const batch = this.batch
      const initial = Number(initial_weight)
      const desired = Number(desired_weight)
      const count = Number(initial_count)

      
      const batchData = {
        batch, 
        accommodation, 
        initial, 
        desired, 
        count,
        animal_type: animal_type ? Number(animal_type) : null,
      }

      if (date_birth) {
        batchData.date_birth = date_birth
        if (this.batchAgeDays != null) {
          batchData.days_life = this.batchAgeDays
        }
      }

      const response = await this.$store.dispatch("editBatch", batchData);

      if (response.ok) {
        this.$refs.errorAlert.closeAlert();
        this.$refs.successAlert.closeAlert();
        this.$refs.successAlert.alert();
        this.updateDataBatch()
        this.handleClose()
      } 
      else {
        this.$refs.errorAlert.closeAlert();
        this.$refs.successAlert.closeAlert();
        this.$refs.errorAlert.alert();
      }

      document.body.style.cursor = "default";
      this.button = "button";
    },
    handleClose() {
      this.$refs.closeButton.click();
    },
    async updateDataBatch(){
      try {
        let url_to_fetch = apiRoutes.batchHomeByBarn(this.barn.pk)
        await fetch(url_to_fetch, {headers: this.$store.getters.getHeader})
        .then(response => response.json())
      } catch (error) {
        console.log(error)
      }
    }
  },
  computed: {
    inicial_weight() {
      if (this.batch == null) return null
      return this.batchDetail?.average_initial_weight ?? ""
    },
    desired_weight() {
      if (this.batch == null) return null
      return this.batchDetail?.desired_weight ?? ""
    },
    initial_count() {
      if (this.batch == null) return null
      return this.batchDetail?.initial_count ?? ""
    },
    accommodation() {
      if (this.batch == null) return null
      return this.batchDetail?.date_accomodation ?? ""
    },
    batchReferenceEndDate() {
      const departure = this.batchDetail?.date_departure ?? this.batch?.date_departure
      return departure || new Date().toISOString().slice(0, 10)
    },
    batchAgeDays() {
      if (this.form_date_birth) {
        return this.dateCompare(this.form_date_birth, this.batchReferenceEndDate)
      }

      const storedDays = Number(this.batchDetail?.days_life)
      if (Number.isFinite(storedDays) && storedDays > 0) {
        return Math.round(storedDays)
      }

      const accommodation = this.form_accommodation || this.batchDetail?.date_accomodation
      if (accommodation) {
        return this.dateCompare(accommodation, this.batchReferenceEndDate)
      }

      return null
    },
    batchAgeDisplay() {
      if (this.batchAgeDays == null || this.batchAgeDays <= 0) return ""
      return `${this.batchAgeDays} dias`
    },
    batchID() {
      if (this.batch == null) {
        return ""
      }
      return `${this.batch.pk}`
    },
    batch() {
      return this.$store.getters.getBatchTarget
    },
    barn() {
      return this.$store.getters.getBarnTarget;
    },
    farm() {
      return this.$store.getters.getAllBarns?.find(obj => {
        return obj.barn?.find(element => element.pk == this.barn?.pk)
      })
    },
    animalTypes() {
      const types = this.$store.getters.getAnimalTypes
      if (!types) return []
      const company = this.farm?.farm?.company
      if (company == null) return types
      return types.filter(type => type.company === company)
    },

  },
};
</script>

<style scoped>
.modal-title {
  margin-bottom: 0;
  line-height: 1.5;
  padding-left: 10px;
}

select {
  margin: 0px;
  margin-top: 5px;
  padding-left: 0px;
}

.modal-body select {
  padding-left: 6px;
}

.modal-body label {
  padding-left: 12px;
}

.optional-hint {
  font-size: 12px;
  font-weight: 400;
  color: #6b6c6c;
}

.form-control[readonly] {
  background-color: #f0f0f0;
  cursor: default;
}

.register-icon {
  margin-bottom: 4.5px;
}

.button {
  color: #fff;
  background-color: #78b843;
  border-radius: 8px;
  border: none;
  padding: 10px 20px;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 300;
  margin-top: 20px;
}

.button:hover {
  background-color: #1b4238;
  color: #fff;
  text-decoration: none;
}

.button-disable {
  color: #fff;
  background-color: #999999;
  border-radius: 8px;
  border: none;
  padding: 10px 20px;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 300;
  margin-top: 20px;
  cursor: not-allowed;
  outline: none;
}
</style>
